@if(title) {
<h2 mat-dialog-title>{{ title }}</h2>
}
<mat-dialog-content class="mat-typography">
  <ng-content></ng-content>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-button mat-dialog-close [disabled]="isActionInProgress" (click)="secondaryAction()" [disabled]="isCancelDisabled">
    {{secondaryActionLabel}}
  </button> -->
  <!-- <button
  mat-button
  mat-dialog-close
  class="decline-btn"
  (click)="secondaryAction()"
  [disabled]="isCancelDisabled || isActionInProgress">
  {{ secondaryActionLabel }}
</button> -->

@if (showSecondaryAction) {
<button
  mat-button
  type="button"
  [class]="secondaryActionClass"
  (click)="secondaryAction()"
  [disabled]="isCancelDisabled || isActionInProgress || isSecondaryActionInProgress"
  [class.spinner]="isSecondaryActionInProgress">
  {{ secondaryActionLabel }}
</button>
}

 @if(showReset) {
  <button mat-button mat-raised-button class="reset-btn" (click)="reset()" [disabled]="isActionInProgress">
    {{ resetLabel }}
  </button>
  }


  <!-- @if(showReset) {
  <button mat-button mat-raised-button class="reset-btn" (click)="reset()" [disabled]="isActionInProgress">
    {{ resetLabel }}
  </button>
  } -->
  <!-- <button mat-button mat-raised-button [color]="actionColor" cdkFocusInitial class="action-btn" (click)="saveData()"
    [class.spinner]="isActionInProgress" [disabled]="isActionDisabled || isActionInProgress">
    {{ actionLabel }}
  </button> -->

<button
  mat-raised-button
  class="action-btn gradient-btn"
  (click)="saveData()"
  [class.spinner]="isActionInProgress"
  [disabled]="isActionDisabled || isActionInProgress || isSecondaryActionInProgress">
  {{ actionLabel }}
</button>


</mat-dialog-actions>
